import { render, staticRenderFns } from "./Logos2Demo.vue?vue&type=template&id=3fcfdce6&"
import script from "./Logos2Demo.vue?vue&type=script&lang=js&"
export * from "./Logos2Demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports